function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M50 44.769l-3.8 4.345 3.8 3.328 3.8-3.328zM0 8.692l46.2 40.422 7.6-8.691L7.605 0zm53.8 40.422L100 8.692 92.4 0 46.2 40.423z"
});

var SvgChevronDown = function SvgChevronDown(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 100 52.442"
  }, props), _ref);
};

export default SvgChevronDown;